export function formatPleskBytes(value: string | null): string {
  return formatBytes(value, 1024n, ['o', 'Kio', 'Mio', 'Gio', 'Tio', 'Pio']);
}

/** Unités décimales demandées pour les sauvegardes : 1 Mo = 1 000 000 octets.
 * Convertir la quantité plutôt que renommer une valeur binaire. */
export function formatBackupBytes(value: string | null): string {
  return formatBytes(value, 1000n, ['o', 'Ko', 'Mo', 'Go', 'To', 'Po']);
}

function formatBytes(value: string | null, base: bigint, units: readonly string[]): string {
  if (value === null) return 'Non retourné';
  const bytes = BigInt(value);
  let divisor = 1n,
    unit = 0;
  while (bytes / divisor >= base && unit < units.length - 1) {
    divisor *= base;
    unit++;
  }
  const tenths = (bytes * 10n) / divisor;
  return `${tenths / 10n}${unit && tenths % 10n ? ',' + String(tenths % 10n) : ''} ${units[unit]}`;
}
